import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M18 18v-6a3 3 0 0 0 -3 -3h-10l4 -4m0 8l-4 -4","key":"svg-0"}]]

const IconCornerUpLeft = createReactComponent('outline', 'corner-up-left', 'CornerUpLeft', __iconNode);

export default IconCornerUpLeft;